
import { useEffect, useState } from 'react';

import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';

import { useDispatch } from 'react-redux';

import { logout } from '../store/slices/AuthSlice';

import { Logout, ValidarToken } from '../connections/auth/AuthConnection';

export const DialogTokenExpired = () => {

    const dispatch = useDispatch();

    const [open, setOpen] = useState( false );

    const [loading, setLoading] = useState( false );

    const IniciarSesion = async () => {

        setLoading( true );

        await Logout().then( resp => {
        
            const { success } = resp;

            if( success ){

                setTimeout(() => {

                    window.localStorage.clear();
                    dispatch( logout() );

                }, 700);   

            }
            else {

                setTimeout(() => {
                    
                    setLoading( false );
                
                }, 700);  

            }

        });                  

    }

    useEffect(() => {
       
        async function Obtener(){

            await ValidarToken().then( response => {

                if( response ){

                    if( response.success === false ){
                        setOpen( true );
                    }

                }
            });

        }

        Obtener();

    }, [ ] );

    return (
        <>
            <Dialog open={ open } onClose={ () => {} } >

                <DialogTitle>
                    El tiempo de sesión ha expirado
                </DialogTitle>

                <DialogContent>

                    <DialogContentText>
                        Por seguridad es necesario volver a iniciar sesión
                    </DialogContentText>

                </DialogContent>

                <DialogActions>

                    <Button 
                        variant='contained' 
                        color='primary' 
                        onClick={ IniciarSesion } 
                        loading={ loading }
                    >
                        Aceptar
                    </Button>

                </DialogActions>

            </Dialog>  
        </>
    );
}